import React from "react";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Collapse from "react-bootstrap/Collapse";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from "react-redux";
import marker from "../../Assetes/Images/pin-red.png";
import { SimplexMap } from "@simplex/map";
import * as geolib from 'geolib';
import { toast } from "react-toastify";
import useLocationEnabled from "../../hooks/useLocationEnabled";
import { useTranslation } from "react-i18next";
import GoogleMapComponent from "../../Components/GoogleMaps/googleMaps";
import "../../Components/GoogleMaps/index.css";
import axios from "axios";
import { API_URL } from "../../Components/client-config";
import { MAPS_COUNTRY } from "../../lib";
import useCurrentLocale from "../../hooks/useLanguage";

export default function NewAddress(props: any) {
	const token = localStorage.getItem("userToken");
	const isLogged = useSelector((state: any) => state.customer.isLogged);
	const [nameError, setNameError] = useState(false);
	const [storeName, setStoreName] = useState("");
	const [numberError, setNumberError] = useState(false);
	const [enableLocation, setEnableLocation] = useState(true);
	const [extraDetailError, setExtraDetailError] = useState(false);
	const [coordinatesString, setCoordinatesString] = useState<string>("");
	const [isCoordinatesStringLoading, setIsCoordinatesStringLoading] =
		useState<boolean>(false);
	const [deliveryLat, setDeliveryLat] = useState(0);
	const [deliveryLng, setDeliveryLng] = useState(0);
	const [searchString, setSearchString] = useState("");
	const [placesSuggestion, setPlacesSuggestion] = useState([]);
	const lang = useCurrentLocale();
	const googleMapCenter =
		props.position &&
			props.position.lat !== "" &&
			props.position.lng !== "" &&
			!Number.isNaN(Number(props.position.lat)) &&
			!Number.isNaN(Number(props.position.lng))
			? {
				lat: Number(props.position.lat),
				lng: Number(props.position.lng),
			}
			: null;
	console.log({ coordinatesString, isCoordinatesStringLoading });
	const updateStoreByCoordinates = (lat: number, lng: number) => {
		let data: any = [];
		for (let i = 0; i < props.storesList.length; i++) {
			if (props.storesList[i].trade_zone_id.zone_json) {
				if (
					geolib.isPointInPolygon(
						{ latitude: lat, longitude: lng },
						JSON.parse(props.storesList[i].trade_zone_id.zone_json)
					)
				) {
					data.push(props.storesList[i]);
				}
			}
		}

		if (data.length > 0) {
			setStoreName(data[0].store_name);
		} else {
			setStoreName("");
		}
	};

	const handleMapData = (obj: any) => {
		setDeliveryLat(obj.lat);
		setDeliveryLng(obj.lng);
		setCoordinatesString(obj.address || "");
		props.setSearchString(obj.address || "");
		updateStoreByCoordinates(Number(obj.lat), Number(obj.lng));
		props.handleMapData(obj);
	};

	const setCurrentLocation = () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position: any) => {
					const center = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					const geocoder = new google.maps.Geocoder();
					geocoder.geocode(
						{
							location: center,
						},
						(results: any, status) => {
							if (status === "OK" && results[0]) {
								handleMapData({
									lat: center.lat,
									lng: center.lng,
									address: results[0].formatted_address,
								});
							} else {
								console.error("Geocoding failed:", status);
							}
						}
					);
				},
				() => {
					toast.error(<>{t("enableAndSearchLocation")}</>);
				},
				{ maximumAge: 20000, timeout: 20000, enableHighAccuracy: false }
			);
		} else {
			toast.error(<>{t("enableAndSearchLocation")}</>);
		}
	};

	useEffect(() => {
		const delayDebounce = setTimeout(() => {
			if (
				process.env.REACT_APP_GOOGLE_MAPS_ENABLE === "true" &&
				searchString.length > 3 &&
				searchString.length < 50
			) {
				axios
					.get(
						`${API_URL}customer/autoComplete/${MAPS_COUNTRY}/${lang}/${searchString}`,
						{
							headers: {
								"x-api-key": process.env.REACT_APP_X_API_KEY,
							},
						}
					)
					.then((res: any) => {
						setPlacesSuggestion(res.data.data);
					})
					.catch((err: any) => {
						console.error("Autocomplete error:", err);
					});
			} else {
				setPlacesSuggestion([]);
			}
		}, 500);
		return () => clearTimeout(delayDebounce);
	}, [searchString]);

	const onPlaceClick = (place: any) => {
		const geocoder = new google.maps.Geocoder();
		geocoder
			.geocode({ placeId: place.place_id })
			.then((response: any) => {
				if (response.results && response.results.length > 0) {
					const location = response.results[0].geometry.location;
					const obj = {
						lat: location.lat(),
						lng: location.lng(),
						address: place.description,
					};
					handleMapData(obj);
					setSearchString("");
					setPlacesSuggestion([]);
				} else {
					console.error("No results found");
				}
			})
			.catch((error: any) => {
				console.error("Geocode error:", error);
			});
	};

	const removeSearchString = () => {
		setSearchString("");
		setPlacesSuggestion([]);
	};

	const handleInputChange = (event: any) => {
		setSearchString(event.target.value);
	};

	const blockInvalidCharForName = (e: any) => {
		[
			"@",
			"+",
			"-",
			"=",
			"/",
			"!",
			">",
			"<",
			"%",
			"&",
			"*",
			"(",
			")",
			"_",
			"{",
			"}",
			"[",
			"]",
			"|",
			":",
			";",
			"?",
			"#",
			"$",
			"^",
		].includes(e.key) && e.preventDefault();
	};
	const clearSearch = () => {
		let doc: any = document.getElementById("txtSearch")!;
		doc.value = "";
	};
	const handleStreetName = (e: any) => {
		props.setStreetName(e.target.value);
		if (e.target.value.length <= 0) setNameError(true);
		else setNameError(false);
	};
	const handleStreetNumber = (e: any) => {
		props.setStreetNumber(e.target.value);
		if (e.target.value.length <= 0) setNumberError(true);
		else setNumberError(false);
	};
	const handleEnableLocation = (value: any) => {
		setEnableLocation(value);
	};
	const handleExtraDetail = (e: any) => {
		props.setExtraDetails(e.target.value);
		if (e.target.value.length <= 0) setExtraDetailError(true);
		else setExtraDetailError(false);
	};
	useEffect(() => {
		navigator.geolocation.getCurrentPosition(
			(position) => { },
			(error) => {
				setEnableLocation(false);
			}
		);
		props.setStreetName("");
		props.setStreetNumber("");
		props.setExtraDetails("");
		let detectOS: any = null
		if (navigator.appVersion.indexOf("Mac") != -1) detectOS = "MacOS";
		if (detectOS && detectOS == "MacOS") {
			setTimeout(() => {
				let doc = document as any;
				if (doc) {
					const btn: any = doc.querySelector(".go-to-location-wrapper")?.querySelector("button");
					if (btn && !btn?.disabled) btn?.click()
				}
			}, 500)
		}
	}, []);
	const confirmLocationReady = () => {
		let data: any = [];
		for (let i = 0; i < props.storesList.length; i++) {
			if (props.storesList[i].trade_zone_id.zone_json) {
				if (geolib.isPointInPolygon({ latitude: deliveryLat, longitude: deliveryLng }, JSON.parse(props.storesList[i].trade_zone_id.zone_json))) {
					data.push(props.storesList[i]);
				}
			}
		}
		//here
		return (
			data.length > 0 &&
			props.position &&
			props.position.lat !== "" &&
			props.position.lng !== "" &&
			props.searchString && props.searchString !== ""
		);
	};
	const isLocationEnabled: boolean = useLocationEnabled();
	useEffect(() => {
		if (!isLocationEnabled) {
			toast.error(<>{t("enableAndSearchLocation")}</>);
		}
	}, [isLocationEnabled]);
	const { t } = useTranslation();

	return (
		<div>
			{token && props.savedAddresses.length > 0 && (
				<Button
					onClick={() => {
						if (props.onAddAddressClick) props.onAddAddressClick();
						props.setSaveAddressSelect(false);
						props.handLeChangeLocation();
						setTimeout(() => {
							let doc = document as any;
							if (doc) {
								const btn: any = doc.querySelector(".go-to-location-wrapper")?.querySelector("button");
								if (btn && !btn?.disabled) btn?.click()
							}
						}, 500)
					}}
					aria-expanded={
						props.changeLocation ||
							!token ||
							props.savedAddresses.length == 0
							? true
							: false
					}
					className="w-50 w-auto m-auto d-flex mt-2 color-white px-2 white-space"
					color="error"
					variant="outlined"
				>
					<i className="ri-add-line delete-btn color-white"></i> {t("ADDADDRESS")}
				</Button>
			)}
			<Collapse
				in={
					props.changeLocation ||
						!token ||
						props.savedAddresses.length == 0
						? true
						: false
				}
			>
				<div className="new-address ">
					<div className="mt-3">
						<fieldset className="d-fieldset">
							<legend className="d-legend f-w-700">
								{t("ENTERFULLADDRESS")}
							</legend>
							{(props.changeLocation ||
								!token ||
								props.savedAddresses.length == 0) &&
								(process.env.REACT_APP_GOOGLE_MAPS_ENABLE === "true" ? (
									<>
										<div className="input-container">
											<div className="flex justify-between items-center gap-2 my-2">
												<div className="d-flex justify-content-between relative w-full">
													<div className="input-container">
														<input
															className="custom-input custom-imput-modal text-base w-full"
															type="text"
															placeholder={t("ENTERFULLADDRESS")}
															value={searchString}
															onChange={handleInputChange}
														/>
														<span className="focus-border"></span>
													</div>
													{searchString?.length > 0 && (
														<button
															className="btn position-absolute top-0 end-0 p-0 mt-1 me-2"
															onClick={removeSearchString}
															style={{
																border: "none",
																background: "transparent",
															}}
														>
															<i className="ri-close-fill text-primary-color-1 fs-4"></i>
														</button>
													)}
												</div>
												<button
													className="btn text-white py-1 px-2 rounded"
													onClick={setCurrentLocation}
													style={{
														backgroundColor: "#e4002b",
														borderColor: "#e4002b",
													}}
												>
													<i className="ri-focus-3-fill"></i>
												</button>
											</div>
											<span className="focus-border"></span>
											{searchString !== "" &&
												placesSuggestion.length > 0 && (
													<div className="address-suggestion">
														<ul>
															{placesSuggestion.map((place: any) => {
																return (
																	<li
																		onClick={() => onPlaceClick(place)}
																		className="suggestion-item"
																	>
																		<span className="upper-text">
																			<strong>
																				{place.structured_formatting.main_text}
																			</strong>
																		</span>
																		<span className="bottom-text">
																			{place.structured_formatting.secondary_text}
																		</span>
																	</li>
																);
															})}
														</ul>
													</div>
												)}
										</div>
										<GoogleMapComponent
											setAddress={(address: string) => {
												setCoordinatesString(address || "");
												props.setSearchString(address || "");
											}}
											onSetData={handleMapData}
											mapCenter={googleMapCenter}
											storeName={storeName}
											setCurrentLocation={setCurrentLocation}
											onPopupBtnClick={props.closeDeliveryOpenPickup}
										/>
									</>
									) : (
										props.storesList && props.storesList.length > 0 && <SimplexMap
											UiSettings={{
												showCurrentLocationBlip: false,
												showGoToCurrentLocationButton: true,
												primaryColor: "#e4002b",
												markersSrc: {
													pin: "/pin-red.png",
												},
												mapZoomLevel: 16,
												loadingLogo: "/KFC-Logo-Red.png",
												defaultCoordinates: [
													67.1405685813624,
													25.03528244630005,
												],
											}}
											setCurrentMarkerCoordinates={(
												coordinates: number[]
											) => {
												setDeliveryLat(coordinates[1]);
												setDeliveryLng(coordinates[0]);
												updateStoreByCoordinates(
													coordinates[1],
													coordinates[0]
												);
												props.handleMapData({
													lng: coordinates[0],
													lat: coordinates[1],
												});
											}}
											setCurrentUserLocationCoordinates={(
												coordinates: number[]
											) =>
												console.log(
													"current user coords ->",
													coordinates
												)
											}
											setCoordinateString={(
												searchResult: any
											) => {
												props.setSearchString(
													searchResult?.toString()
												);
												setCoordinatesString(
													searchResult?.toString()
												);
											}}
											setIsCoordinateStringLoading={(
												flag: boolean
											) =>
												setIsCoordinatesStringLoading(flag)
											}
											apiKey={process.env.REACT_APP_SM_KEY}
											popupText={storeName}
											popupOpts={{
												allowClose: false,
												offset: {
													x: 0,
													y: 0,
												},
											}}
										/>
									))}
						</fieldset>
					</div>
					<div className="row py-2">
						<div className="col-1 d-flex align-items-center">
							<img
								width={25}
								height={25}
								src={marker}
								id="address-marker"
								alt=""
							/>
						</div>
						<div className="col-11 mt-2">
							{/* <input value={props.searchString} disabled className="col-12 form-control" style={{ margin: "auto" }} /> */}
							<h5 title={coordinatesString}>
								{isCoordinatesStringLoading
									? "Loading..."
									: isLocationEnabled
										? coordinatesString === "404" ? <>{t("ADDRESSNOTFOUND")}</> : coordinatesString
										: coordinatesString !== ""
											? coordinatesString === "404" ? <>{t("ADDRESSNOTFOUND")}</> : coordinatesString
											: <>{t("enableAndSearchLocation")}</>}
							</h5>
						</div>
						{!props.confirmAdd && (
							<div className="col-md-12">
								<Button
									disabled={!confirmLocationReady()}
									onClick={() => {
										let windowObj = window as any;
										windowObj.dataLayer.push({
											ecommerce: null,
										});
										windowObj.dataLayer.push({
											event: "confirm_location_success",
										});
										props.setConfirmAddress(true);
									}}
									className={`${!confirmLocationReady()
										? "disable-btn"
										: "able-btn"
										}
                     'm-auto d-flex mt-2 bg-theme w-100 deliver-btn'`}
									variant="contained"
									color="error"
									style={{
										textTransform: "capitalize",
										fontSize: "1em",
										zIndex: 9999,
										cursor: confirmLocationReady()
											? "pointer"
											: "no-drop",
										backgroundColor: confirmLocationReady()
											? "rgb(0,105,145)"
											: "rgb(128, 128, 128)",
									}}
								>
									<strong>{t("CONFIRMLOCATION")}</strong>
								</Button>
							</div>
						)}
						{/* <div className="col-6 mt-2">
                            <TextField
                                helperText={nameError ? "This field is required" : ""}
                                className='field-style' id="filled-basic" label="Street Name *" variant="filled" color="error" autoComplete="off" value={props.street_name} onKeyDown={blockInvalidCharForName} onChange={handleStreetName} />
                        </div>
                        <div className="col-6 mt-2">
                            <TextField
                                helperText={numberError ? "This field is required" : ""}
                                className='field-style' id="filled-basic" label="Street Number/Sector/Block *" variant="filled" color="error" autoComplete="off" value={props.street_number} onKeyDown={blockInvalidCharForName} onChange={handleStreetNumber} />
                        </div> */}
						{props.confirmAdd && (
							<>
								<div className="col-md-12 kfc-new-address-web">
									<TextField
										helperText={
											nameError
												? "This field is required"
												: ""
										}
										className="field-style"
										id="filled-basic"
										placeholder="House / Flat / Apartment / Office Number *"
										variant="filled"
										color="error"
										autoComplete="off"
										value={props.street_name}
										onKeyDown={blockInvalidCharForName}
										onChange={(e) => {
											var inputValue =
												e.target.value.trimStart();
											e.target.value = inputValue;
											handleStreetName(e);
										}}
									/>
								</div>
								<div className="col-md-12 mt-3">
									<TextField
										helperText={
											numberError
												? "This field is required"
												: ""
										}
										className="field-style"
										id="filled-basic"
										placeholder="Block / Sector / Street / Building / Floor Name or Number *"
										variant="filled"
										color="error"
										autoComplete="off"
										value={props.street_number}
										onKeyDown={blockInvalidCharForName}
										onChange={(e) => {
											var inputValue =
												e.target.value.trimStart();
											e.target.value = inputValue;
											handleStreetNumber(e);
										}}
									/>
								</div>
								<div className="col-md-12 mt-3">
									<TextField
										helperText={extraDetailError ? t("FIELD_REQUIRED") : ""}
										className="field-style"
										id="filled-basic"
										placeholder={t("EXTRA_DETAILS_PLACEHOLDER")}
										variant="filled"
										color="error"
										autoComplete="off"
										value={props.extra_details}
										onKeyDown={blockInvalidCharForName}
										onChange={(e) => {
											var inputValue =
												e.target.value.trimStart();
											e.target.value = inputValue;
											handleExtraDetail(e);
										}}
									/>
								</div>
							</>
						)}
						{props.saveAddressCheck && (
							<FormControl>
								<RadioGroup
									row
									aria-labelledby="demo-row-radio-buttons-group-label"
									name="row-radio-buttons-group"
									className="justify-content-center mt-3"
									onChange={props.handlePlace}
								>
									<FormControlLabel
										className="control-lable color-white"
										value={"home"}
										control={
											<Radio
												color="error"
												checked={props.place == "home"}
											/>
										}
										label={t("HOME")}
									/>
									<FormControlLabel
										className="color-white"
										value={"office"}
										control={
											<Radio
												color="error"
												checked={
													props.place == "office"
												}
											/>
										}
										label={t("OFFICE")}
									/>
									<FormControlLabel
										className="color-white"
										value={"other"}
										control={
											<Radio
												color="error"
												checked={props.place == "other"}
											/>
										}
										label={t("OTHER")}
									/>
								</RadioGroup>
							</FormControl>
						)}
						{isLogged && (
							<FormGroup>
								<FormControlLabel
									className="color-white"
									control={
										<Checkbox
											className="color-theme"
											onClick={() =>
												props.setSaveAddress(
													!props.saveAddressCheck
												)
											}
											checked={props.saveAddressCheck}
										/>
									}
									label={t("SAVEADDRESS")}
								/>
							</FormGroup>
						)}
					</div>
				</div>
			</Collapse>
		</div>
	);
}
